import { Data } from '@/modules/shared/models/data'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'

export enum BankAccountType {
  NATURAL_PERSON = 'natural-person',
  LEGAL_PERSON = 'legal-person'
}

export enum BankAccountWithdrawPeriod {
  OFF = 'off',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  HALF_MONTHLY = 'half_monthly',
  MONTHLY = 'monthly',
}

export enum BankAccountWithdrawPeriodDay {
  SATURDAY,
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
}

export enum BankNames {
  MELLI = 'melli',
  EQTESAD = 'eqtesad',
  MEHR = 'mehr',
  SEPAH = 'sepah',
  PARSIAN = 'parsian',
  RESALAT = 'resalat',
  SANAT_MADAN = 'sanat_madan',
  KARAFARIN = 'karafarin',
  KESHAVARZI = 'keshavarzi',
  SAMAN = 'saman',
  MASKAN = 'maskan',
  SINA = 'sina',
  SADERAT = 'saderat',
  KHAVARMIANE = 'khavarmiane',
  TAAVON = 'taavon',
  SHAHR = 'shahr',
  POSTBANK = 'postbank',
  DEI = 'dei',
  TOSEE_SADERAT = 'tosee_saderat',
  MELLAT = 'mellat',
  TEJARAT = 'tejarat',
  REFAH = 'refah',
  HEKMAT = 'hekmat',
  GARDESHGARI = 'gardeshgari',
  IRANZAMIN = 'iranzamin',
  GHAVAMIN = 'ghavamin',
  ANSAR = 'ansar',
  SARMAYEH = 'sarmayeh',
  PASARGAD = 'pasargad',
  AYANDEH = 'ayandeh',
  KOSAR = 'kosar',
}

export interface BankAccountResourceModel {
  id: number,
  account_type: BankAccountType,
  account_owner_name: string,
  card_number: number | string | null,
  sheba: number | string | null,
  bank_name: BankNames | null,
  withdraw_period?: BankAccountWithdrawPeriod,
  withdraw_period_day?: BankAccountWithdrawPeriodDay
  national_identity_image: Array<File | MediaResourceModel>
}

export interface BankAccountResourceWithModel {
  bank_names: { [key in BankNames]: string }
  bank_account_withdraw_periods: { [key in BankAccountWithdrawPeriod]: string }
}

export interface OwnBankInfoResourceModel {
  sheba: string
  name: string
  bank_name: string
  card: string
}

export type BankAccountResourceType = Data<BankAccountResourceModel> & BankAccountResourceWithModel